import { render } from "./AddProduct.vue?vue&type=template&id=f93ab172"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__